import { request } from "@/interface/helper";

const str = "StatsList";

export const StatsList = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/stats/list" }),
    detail: data => request({ data, method: "post", url: "/stats/detail" }),

  }
};
